import { useContext, useRef, useEffect, useState } from 'react';

import styles from './MonthsComponent.module.css'

import { GlobalContext } from "../../../contexts/globalContext";

const MonthsComponent = ({ selectedDate, setSelectedDate, setChangedMonth }) => {

    const { setAlertMessage } = useContext(GlobalContext);

    const containerRef = useRef();
    const selectedMonthRef = useRef();
    const scrollTimeoutRef = useRef(null);
    const clickedRef = useRef(true);
    const selectedDateRef = useRef();
    const beginningYear = useRef(selectedDate.getFullYear())

    const currentDate = new Date();
    const months = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const [monthsArray, setMonthsArray] = useState(addYears(2,[]))


    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        container.addEventListener("scroll", handleScroll);

        return () => {
            container.removeEventListener("scroll", handleScroll);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        selectedDateRef.current = new Date(selectedDate)

        if(selectedDate.getFullYear() > beginningYear.current){
            setMonthsArray(addYears(1, monthsArray))
        }

        if (selectedMonthRef.current && containerRef.current) {
            const container = containerRef.current;
            const selectedElement = selectedMonthRef.current;

            const containerWidth = container.offsetWidth;
            const selectedWidth = selectedElement.offsetWidth;
            const selectedLeft = selectedElement.offsetLeft;

            const scrollLeft = selectedLeft - (containerWidth / 2) + (selectedWidth / 2);
            container.scrollTo({ left: scrollLeft, behavior: "smooth" });
        }
    }, [selectedDate]);

    const handleScroll = () => {
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }

        scrollTimeoutRef.current = setTimeout(() => {
            if (!containerRef.current || clickedRef.current) {
                clickedRef.current = false
                return;
            }

            const container = containerRef.current;
            const center = container.scrollLeft + container.offsetWidth / 2;

            let closestIndex = -1;
            let closestDistance = Infinity;

            const monthElements = container.children;

            Array.from(monthElements).forEach((month, index) => {
                const monthCenter = month.offsetLeft + month.offsetWidth / 2;
                const distance = Math.abs(center - monthCenter);

                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestIndex = index - 12 - monthDiff(selectedDateRef.current); 
                }
            });

            if (compareMonths(closestIndex, selectedDateRef.current) || closestIndex > 11) {
                let newDate = new Date(selectedDateRef.current)
                newDate.setMonth(closestIndex)
                setSelectedDate(newDate)
                setChangedMonth(true)
                clickedRef.current = true

            } else {
                setAlertMessage({ type: "ERROR", message: `The selected month is in the past.` });
            }
            
        }, 200);
    };

    function compareMonths(index, date) {
        if (date && currentDate.getMonth() > index && date.getFullYear() === currentDate.getFullYear()){
            return 0
        } 
        return 1
    }

    function onClickMonth(index) {
        if (compareMonths(index, selectedDate)) {
            let newDate = new Date(selectedDate)
            newDate.setMonth(index)
            setSelectedDate(newDate)
            setChangedMonth(true)
            clickedRef.current = true
        } else {
            setAlertMessage({ type: "ERROR", message: `The selected month is in the past.` });
        }
    }

    function monthDiff(date){
        return (date.getFullYear() - beginningYear.current) * 12
    }

    function addYears(numYears, array){
        if (numYears < 0) return [];
  
        let result = array;

        for (let i = 0; i <= numYears; i++) {
            result = result.concat(months);
        }
        
        return result;
    }

    return (
        <div ref={containerRef} className={styles.monthsArray} >
            {monthsArray.map((month, index) =>
                <div
                    key={index}
                    ref={ monthDiff(selectedDate) + selectedDate.getMonth() === index - 12 ? selectedMonthRef : null}
                    className={ monthDiff(selectedDate) + selectedDate.getMonth() === index - 12 ? styles.selectedMonth : styles.month}
                    style={{ opacity: compareMonths(index - 12 - monthDiff(selectedDate), selectedDate) ? 1 : 0.5 }}
                    onClick={() => onClickMonth(index - 12 - monthDiff(selectedDate))}
                >
                    {month}
                </div>
            )}
        </div>
    );

}

export default MonthsComponent;